export { default as Icon } from './icon'
export type { Props as IconProps, Name as IconName, Size as IconSize } from './icon'
